import React, {useEffect, useState, useRef} from 'react';
import Carousel from 'react-multi-carousel';
import UAParser from "ua-parser-js";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import {getLabel} from '../../utils';
import YTVideoItem from '../YTVideoItem/YTVideoItem';
import YTVideoDetail from '../YTVideoDetail/YTVideoDetail';
import YTVideoListHolder from './YTVideoListStyles';

const YTVideoList = ({videos, selectedVideo, onVideoSelect, title, selected, playlistId})=> {
	const [deviceType , setDeviceType] = useState(undefined);
	const carouselContainer = useRef(null);

	const responsive = {
	desktop: {
		breakpoint: { max: 4000, min: 1024 },
		items: 4,
		slidesToSlide: 4,
		},
		tablet: {
		breakpoint: { max: 1024, min: 464 },
		items: 2,
		slidesToSlide: 1,
		},
		mobile: {
		breakpoint: { max: 464, min: 0 },
		items: 1,
		slidesToSlide: 1,
		}
	};

	useEffect(() => {
		if(carouselContainer && carouselContainer.current){
			const elements = document.querySelectorAll(`.${title && title.toLowerCase().replace(/\s/g, '')}-id .carousel-item`);
			elements.length > 0 && [].forEach.call(elements, function(li) {
				li.setAttribute('aria-hidden', 'false');
			});
		}		
	}, [videos]);

	useEffect(()=> {
		const parser = new UAParser();
		const userAgent = navigator.userAgent;
		parser.setUA(userAgent);
		const result = parser.getResult();
		const deviceType = (result.device && result.device.type) || "desktop";
		setDeviceType(deviceType);

	},[]);

	const videoCloseHandlder = () =>{
		onVideoSelect(null);
	}

	const showBigVideo = () => {
		return selectedVideo !== null && playlistId === selected;
	}

	return (
		<section className={`content__carousel ${showBigVideo() ? "expanded" : "constrain"}`} tabIndex="0" aria-label={title}  itemScope="itemscope" itemType="https://schema.org/ItemList">
			<YTVideoListHolder>
				<h2 className="yt-video-list-title" itemProp='name'>{title}</h2>
				<button onClick={videoCloseHandlder} className={`close-btn ${showBigVideo() ? "show" : "hidden"}`}>{getLabel("CLOSE")}<FontAwesomeIcon icon={faTimes} title="close"/></button> 
				<YTVideoDetail video={selectedVideo} selectedVideo={selectedVideo} selected={showBigVideo()} className={`${showBigVideo() ? "show" : "hidden"}`} /> 
				<Carousel
					deviceType={deviceType}
					responsive={responsive}
					arrows={true} 
					//showDots={videos && videos.length > 5 && deviceType == "desktop" ? true : false} 
					transitionDuration={500} autoPlaySpeed={1000}
					containerClass={`carousel-container ${title && title.toLowerCase().replace(/\s/g, '')}-id`}
					itemClass="carousel-item"
					dotListClass="dot-list-style" 
					keyBoardControl={true}
					focusOnSelect={true}
					ref={carouselContainer}>
					{videos && videos.map((video) => {
						return <YTVideoItem key={video.snippet.resourceId.videoId} onVideoSelect={onVideoSelect} video={video}/>
					})}
				</Carousel>
			</YTVideoListHolder>
		</section>
	)
}

export default YTVideoList;